import React, { useState, useEffect } from "react";
import axios from 'axiosInstance';
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPencil,
  faX,
  
}
from '@fortawesome/free-solid-svg-icons';
import Spinner from 'react-bootstrap/Spinner';
import { Table, Button } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';


import './css/Eventos.css';


function Inscripciones() {
  const [inscripciones, setInscripciones] = useState([]);
  const navegar = useNavigate();
   const [cargando, setCargando] = useState(true);

 
  const getUserId = () => {
    const user = JSON.parse(sessionStorage.getItem('user'));
    return user?.id;
  };

  
  const obtenerInscripciones = async () => {
    try {
      const respuesta = await axios.get(process.env.REACT_APP_BACKEND_URL + '/api/inscripciones');
      const userId = getUserId();

      const filtradas = respuesta.data.filter(i => i.user_id === userId);
      setInscripciones(filtradas);
       setCargando(false);
    } catch (error) {
      console.error("Error al obtener las inscripciones:", error);
    }
  };

  const eliminarInscripcion = async (id) => {
    try {
      await axios.delete(process.env.REACT_APP_BACKEND_URL + `/api/inscripciones/${id}`);
     
      setInscripciones(inscripciones.filter(i => i.inscripcion_id !== id));
    } catch (error) {
      console.error("Error al eliminar la inscripción:", error);
    }
  };

  const editarInscripcion = (id) => {
    navegar(`/editarInscripcion/${id}`);
  };
  const crearInscripcion = () => {
    navegar(`/CrearInscripcion`);
  };

  useEffect(() => {
    obtenerInscripciones();
  }, []);

  return (
    <div className="contenedorEventos p-4">
      <div className="justify-content-between align-items-center mb-4">
        <h1 className="tituloEventos m-3">MIS INSCRIPCIONES</h1>
      </div>

      <div className="d-flex justify-content-between align-items-center mb-4">
        <Button className="boton_agregar" onClick={crearInscripcion}>
          Nueva Inscripción
        </Button>
      </div>
{cargando ? (
        <div className="text-center my-5">
          <Spinner animation="grow" role="status" />
          <p className="mt-3">Cargando inscripciones...</p>
        </div>
      ) :
      inscripciones.length > 0 ? (
        <Table striped bordered hover responsive className="tabla-inscripciones">
        <thead>
          <tr>
            <th>Nombre</th>
            <th>DNI</th>
            <th>Tutor</th>
            <th>Evento</th>
            <th>Usuario</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {inscripciones.map(inscripcion => (
            <tr key={inscripcion.inscripcion_id}>
              <td>{inscripcion.nombre} {inscripcion.apellidos}</td>
              <td>{inscripcion.dni}</td>
              <td>{inscripcion.nombre_tutor} {inscripcion.apellidos_tutor}</td>
              <td>{inscripcion.evento?.nombre}</td>
              <td>{inscripcion.user?.name}</td>
              <td>
                <div className="d-flex gap-1 justify-content-center">
                  <Button size="sm" className="boton_accion" onClick={() => editarInscripcion(inscripcion.inscripcion_id)}><FontAwesomeIcon icon={faPencil} size="2x" className="me-2 icono" /> </Button>
                  
                  <Button size="sm"variant="danger"className="boton_accion" onClick={() => eliminarInscripcion(inscripcion.inscripcion_id)}><FontAwesomeIcon icon={faX} size="2x" className="me-2 icono" /></Button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>  
      ) : (
        <p className=" text-center">
         no hay inscripciones a ningun evento
        </p>
      )}
    </div>
  );
}

export default Inscripciones;
